import { render, staticRenderFns } from "./picto-editor.vue?vue&type=template&id=5b509356"
import script from "./picto-editor.vue?vue&type=script&lang=js"
export * from "./picto-editor.vue?vue&type=script&lang=js"
import style0 from "./picto-editor.vue?vue&type=style&index=0&id=5b509356&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports